/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createRotateIntegrationSecretsResponseFromDiscriminatorValue, serializeRotateIntegrationSecretsRequest, serializeRotateIntegrationSecretsResponse, type ErrorResponse, type InternalErrorResponse, type RotateIntegrationSecretsRequest, type RotateIntegrationSecretsResponse } from '../../../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/{organizationId}/integrations/{integrationId}/rotate-secrets
 */
export interface RotateSecretsRequestBuilder extends BaseRequestBuilder<RotateSecretsRequestBuilder> {
    /**
     * Safely rotate integration API keys and secrets with automatic connection testing. Commonly used for security compliance and periodic key rotation.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<RotateIntegrationSecretsResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: RotateIntegrationSecretsRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<RotateIntegrationSecretsResponse | undefined>;
    /**
     * Safely rotate integration API keys and secrets with automatic connection testing. Commonly used for security compliance and periodic key rotation.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: RotateIntegrationSecretsRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const RotateSecretsRequestBuilderUriTemplate = "{+baseurl}/api/organizations/{organizationId}/integrations/{integrationId}/rotate-secrets";
/**
 * Metadata for all the requests in the request builder.
 */
export const RotateSecretsRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: RotateSecretsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createRotateIntegrationSecretsResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeRotateIntegrationSecretsRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
